module.exports = __webpack_public_path__ + "static/homemade-11bc0641638a0287f30fa1517ddd387e.svg";